// components/GlobalLoading.jsx
import React from "react";
import Logo from '../images/logoss.png';


const GlobalLoading = () => {
    return (
        <div className="loading-container">
            <img src={Logo} alt="Loading..." className="bouncing-logo" />
        </div>
    );
};

export default GlobalLoading;
